import React, { useState } from "react";
import { DownOutlined, SmileOutlined } from "@ant-design/icons";
import { Avatar, Dropdown, Space } from "antd";
import { AiOutlineUser } from "react-icons/ai";
import { useNavigate } from "react-router-dom";
import { useMyContext } from "../../context/MyContext";

const HeaderDropdown = ({ user }) => {
  const { logout } = useMyContext();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const handleMenuClick = async (item) => {
    if (item.key === "2") {
      try {
        await logout();
        navigate("/", { replace: true });
      } catch (error) {
        console.error("Logout failed:", error);
        navigate("/", { replace: true });
      }
    } else if (item.key === "1") {
      navigate("/profile");
    }
  };

  const items = [
    {
      key: "1",
      label: "Setting",
    },
    {
      key: "2",
      label: "Logout",
      danger: true,
    },
  ];

  return (
    <Dropdown
      menu={{
        items,
        onClick: handleMenuClick,
      }}
    >
      <a onClick={(e) => e.preventDefault()}>
        <Avatar
          className="flex items-center justify-center"
          icon={<AiOutlineUser />}
          src={user?.profile || user?.imageUrl}
        />
      </a>
    </Dropdown>
  );
};

export default HeaderDropdown;
